import React from "react";

const ModuleTitle = ({ title }) => {
  return (
    <div className="row">
      <div className="formgroups divider-Header">
        <h3>{title} :</h3>
      </div>
    </div>
  );
};

export default ModuleTitle;
